import { render, staticRenderFns } from "./Declarations.vue?vue&type=template&id=cbab55d4&scoped=true"
import script from "./Declarations.vue?vue&type=script&lang=js"
export * from "./Declarations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbab55d4",
  null
  
)

export default component.exports